// extracted by mini-css-extract-plugin
export default {"container":"styles-scoped__container--MWTE4","header":"styles-scoped__header--tywcE","containerBtn":"styles-scoped__containerBtn--U4J3i","btn":"styles-scoped__btn--RpeP8"};